
/**
 * @Description //TODO 加密方式
 * @author Zhangbin
 * @date 2021/4/30 16:43
 * @Ver 1.3.1
 * @extends Vue
 */

import Vue from 'vue'
import md5 from 'js-md5'
import cryptoJs from 'crypto-js'
import GlobalVar from '@/global/global-variable'
import JsEncrpty from 'jsencrypt'
import Base64 from 'js-base64'

Vue.prototype.$md5 = md5;
Vue.prototype.$JsEncrpty = JsEncrpty
Vue.prototype.$base64 = Base64

export default {
/**
 * @Des MD5 加密
 * @Auth Zhangbin
 * @Date 16:21 2021/4/30
 */
  md5: (data) => {
    return md5(data.trim())
  },
  /**
   * @Des AES加密
   * @Auth Zhangbin
   * @Date 16:21 2021/4/30
   */
  encryptAes: (data) => {
    let keyHex = cryptoJs.enc.Utf8.parse(GlobalVar.AES_KEY)
    let ivHex = cryptoJs.enc.Utf8.parse(GlobalVar.AES_AI)
    var dt = cryptoJs.enc.Utf8.parse(data)
    let option = {
      iv: ivHex,
      mode: cryptoJs.mode.CBC,
      padding: cryptoJs.pad.ZeroPadding
    }
    let encrypted = cryptoJs.AES.encrypt(dt, keyHex, option)
    return cryptoJs.enc.Base64.stringify(encrypted.ciphertext)
  },
  /**
   * @Des RSA加密
   * @Auth Zhangbin
   * @Date 16:21 2021/4/30
   */
  encryptRSA: (data, publicKey) =>{
    let encrypt = new JsEncrpty()
    encrypt.setPublicKey(publicKey)
    return encrypt.encrypt(data)
  }
}







// WEBPACK FOOTER //
// ./src/secret/index.js